module.exports = __webpack_public_path__ + "static/media/price-icon.7eb716e8.png";